import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import {
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DownloadInvoiceComponent } from "../download-invoice/download-invoice.component";
import { DeleteComponent } from "../../../../../app/components/delete/delete.component";
import SwalComponent from "../../../../../app/utils/custom-swal.component";
import { DataObject } from "../../../../../app/interfaces/data-objects";
import { ColDef, ITooltipParams } from "ag-grid-community";
import { DateAgGridComponent } from "../../invoice-ag-grid/cell-renderers/date/date-ag-grid.component";
import { TranslateService } from './../../../../api/translate.service';
@Component({
  selector: "iv-document-history",
  templateUrl: "./document-history.component.html",
  styleUrls: ["./document-history.component.scss"],
})
export class DocumentHistoryComponent implements OnInit {
  _transactionId;
  deleteObj: DataObject;
  @ViewChild("warnAlert", { static: true }) warnAlert: SwalComponent;
  deleteConfirmationId: EventEmitter<any>;

  // INFO: This context will hold a reference of the parent, which the child can then access (attributes, functions, etc).
  context: DataObject;
  cellRendererComponents = {
    delete: DeleteComponent,
    date: DateAgGridComponent,
    download: DownloadInvoiceComponent,
  };

  docsHistoryColumnDefs: ColDef[] = [  ];

  deleteColumnDef: ColDef = {
    field: "",
    headerName: " ",
    width: 100,
    cellRenderer: "delete",
  };

  docsHistoryDefaultColDef: ColDef = {
    resizable: false,
    wrapText: true,
    sortable: false,
    filter: false,
    suppressMovable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };

  docsHistoryAutoSizeStrategy = {
    type: "fitGridWidth",
  };

  rowData: DataObject;
  gridApi: DataObject;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      dataSource: DataObject;
      transactionId: any;
      type: string;
      delete: boolean;
    },
    private translateService: TranslateService,
  ) {
    this.deleteConfirmationId = new EventEmitter();
    this.context = { componentParent: this };
    this._transactionId = this.data.transactionId;
    this.docsHistoryColumnDefs = [
      {
        field: "file_name",
        headerName: this.translateService.getTranslation("Name"),
        width: 260,
        tooltipValueGetter: (p: ITooltipParams) => p.value,
        cellClass : "ellipsis"
      },
      {
        field: "date",
        headerName: this.translateService.getTranslation("Date"),
        width: 100,
        cellClass: "ag-flex-align-center",
        cellRenderer: "date",
      },
      {
        field: "view",
        headerName: this.translateService.getTranslation("View"),
        width: 90,
        cellRenderer: "download",
      },
    ]
  }

  ngOnInit() {
    this.getDocumentHistoryData();
  }

  // The gridReady event fires upon grid initialisation but the grid may not be fully rendered
  onGridReady(params: any): void {
    this.gridApi = params.api;
  }

  close() {
    this.dialog.closeAll();
  }

  getDocumentHistoryData() {
    if (this.data.delete) {
      // ag Grid
      this.docsHistoryColumnDefs.push(this.deleteColumnDef);
    }
    const documents =
      this.data.type === "uploaded_documents"
        ? this.data.dataSource
        : [
            ...this.data.dataSource.proforma_fee_advisor,
            ...this.data.dataSource.fee_contracts,
            ...this.data.dataSource.expense_files,
          ];

    this.rowData = documents;
  }

  onDeleteConfirmation(document: DataObject) {
    this.rowData = this.rowData.filter((a: any) => a.id !== document.id);
    this.gridApi.setGridOption("rowData", this.rowData);

    this.deleteConfirmationId.emit(document);
  }
}
